import React, { useEffect, useState } from 'react';
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import App from "./App";
// 注入store
import i18n from './utils/i18n';
import zhCN from 'antd/lib/locale/zh_CN';
import jaJP from 'antd/lib/locale/ja_JP';
import dayjs from 'dayjs';
import { Provider } from "react-redux";
import store from "./store";
import router from "./components/router";
import Comments from "./components/Comments/Comments";
import Checkout from "./components/CheckOut";
import { ConfigProvider, message } from 'antd';
const root = createRoot(document.getElementById("root"));
// 配置错误消息的位置
message.config({
  // @ts-ignore
  top: "20%", // 设置消息显示在画面中央
  duration: 2, // 设置消息显示的持续时间（秒）
  maxCount: 1, // 设置同时显示的最大消息数
});
const LangWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLang] = useState<string>(i18n.language || 'zh');

  useEffect(() => {
    // 当 i18n 语言变化时更新本地 state（用于选择 antd locale）
    const handle = (lng: string) => setLang(lng);
    i18n.on('languageChanged', handle);
    return () => {
      i18n.off('languageChanged', handle);
    };
  }, []);

  useEffect(() => {
    // 同步 dayjs locale
    dayjs.locale(lang === 'ja' ? 'ja' : 'zh-cn');
  }, [lang]);

  const antLocale = lang === 'ja' ? jaJP : zhCN;

  return <ConfigProvider locale={antLocale}>{children}</ConfigProvider>;
};
root.render(
  <Provider store={store}>
    <LangWrapper>
      {/* @ts-ignore */}
      <RouterProvider router={router}>
        <App />
        <Comments></Comments>
        <Checkout></Checkout>
      </RouterProvider></LangWrapper>
  </Provider>
);
